import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  buttons: {
    display: 'flex',
  },
}));

export default useStyles;
